import React from 'react';
import PropTypes from 'prop-types';

/**
 * Currently recommendation does not support dynamic rendering; i.e. the empty div(s) must be
 * available when the page loads. As a workaround, we have our empty recommendation divs in
 * an invisible div in the main `MyApps` component (id is `recommendation` - all empty
 * recommendation divs are supposed to be placed here) and then we move the whole element to
 * this component (with `componentDidMount`) and return it back (with `componentWillUnmount`)
 * when the component unmounts so that we can use it in subsequent mountings.
 */

class MyAppRecCardItem extends React.Component {
  componentDidMount() {
    // find this recommendation
    let element = document.getElementById(this.props.app);

    if (element) {
      let content = document.getElementById(`${this.props.app}Content`);

      if (content) {
        // append the element to this component
        content.appendChild(element);
      }
    }
  }

  componentWillUnmount() {
    // find this recommendation
    let element = document.getElementById(this.props.app);

    if (element) {
      let recommendations = document.getElementById('recommendations');

      if (recommendations) {
        // append the element back to its original locations
        recommendations.appendChild(element);
      }
    }
  }

  render() {
    return <div id={`${this.props.app}Content`} />;
  }
}

MyAppRecCardItem.propTypes = {
  app: PropTypes.string
};

export default MyAppRecCardItem;
